export default __webpack_public_path__ + "static/media/medal.bcb5b605.svg";